import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { UtilityHeader, Footer, SideNav, Logo, typography } from '@awesomecomponents/mux';
import Form from './Form';
import ExitModal from './ExitModal';
import { appConstants } from '../utils/appConstants';
import { BREAKPOINTS } from '@awesomecomponents/mux/core/spacing';
import TimeoutModal from './TimeoutModal';
import { buildFooterMenus, buildHeaderRight } from '../utils/navigationBuilder';
import brandingColors from '@awesomecomponents/mux/core/colors/colors';

const HeaderContainer = styled.div`
  position: relative;
`;

const ActionLink = styled.a`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize};
  line-height: ${typography.lineHeight};
  font-weight: 300;
  color: ${brandingColors.link_green};
  text-decoration: underline;
  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    width: 100%;
    display: block;
  }
`;

const Container = styled.main`
  position: absolute;
  top: 150px;
  left: 100px;
  right: 0;
  bottom: 0;
  overflow: auto;
  background-color: #fafafa;

  @media (max-width: ${BREAKPOINTS.MAX_1600}px) {
    left: 80px;
  }

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    top: 130px;
    left: 0;
  }
`;

const Content = styled.div`
  position: relative;
  min-height: calc(100vh - 250px);
  background-color: #fafafa;
`;

const LogoContainer = styled.div`
  position: fixed;
  top: 40px;
  right: 0;
  left: 100px;
  bottom: 0;
  width: 100%;
  height: 150px;
  overflow: auto;
  background-color: #fafafa;

  @media (max-width: ${BREAKPOINTS.MAX_1600}px) {
    left: 80px;
  }

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    top: 60px;
    left: 0;
  }
`;

const SideNavWrapper = styled.div`
  & nav {
    overflow-y: hidden;
  }
`;

const Clickable = styled.div`
  position: relative;
  width: 114px;
  height: 26px;
  cursor: pointer;
`;

const UtilityClickable = styled.div``;

const SaveExitWrapper = styled.div`
  text-align: right;
  margin-top: 30px;
  margin-right: 150px;

  @media (max-width: ${BREAKPOINTS.MAX_768}px) {
    margin-top: 20px;
    display: 'none';
    width: 95%;
  }
`;

const customStyle = {
  logoWrapperStyle: {
    width: '8%',
    height: '9%',
    margin: '30px 30px',
    media: {
      [BREAKPOINTS.MAX_768]: {
        display: 'none',
      },
    },
  },
  imageStyle: {
    width: '114px',
    height: '26px',
  },
};

const FormHero = ({ business_unit, form_name, lang, langContent, isAuthenticated, setIsAuthenticated }) => {
  const { SAVE_AND_EXIT } = langContent;
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  const { EXIT, IDLE_TIMER, IDLE_TIMER_REMAINING, INTERVAL_TIME, DEBOUNCE_TIME, FLOW_AUTH } = appConstants;
  const onHandleClick = (e) => {
    e.preventDefault();
    setIsExitModalOpen(true);
  };
  return (
    <Fragment>
      <HeaderContainer>
        {window.innerWidth < BREAKPOINTS.MAX_768 ? (
          <UtilityClickable onClick={setIsExitModalOpen}>
            <UtilityHeader
              rightItems={buildHeaderRight(lang)}
              rightMobileItems={buildHeaderRight(lang)}
              showLangToggle={false}
              showSignin={false}
              lang={lang}
            />
          </UtilityClickable>
        ) : (
          <UtilityHeader
            rightItems={buildHeaderRight(lang)}
            rightMobileItems={buildHeaderRight(lang)}
            showLangToggle={false}
            showSignin={false}
            lang={lang}
          />
        )}
        <SideNavWrapper>
          <SideNav lang={lang} showSignIn={false} showContactUs={false} brandLink={() => setIsExitModalOpen(true)} />
        </SideNavWrapper>
      </HeaderContainer>
      <LogoContainer>
        <table style={{ width: '100%' }}>
          <tr>
            <th style={{ 'text-align': 'left' }}>
              {window.innerWidth > BREAKPOINTS.MAX_768 && (
                <Clickable>
                  <Logo
                    alt="Manulife"
                    onClick={setIsExitModalOpen}
                    lang={lang}
                    variant="black_wordmark"
                    customStyle={customStyle}
                  />
                </Clickable>
              )}
            </th>
            <th style={{ 'text-align': 'right' }}>
              <SaveExitWrapper>
                {isAuthenticated && (
                  <ActionLink data-testid="saveExitBtn" href="#" key="save_and_exit" onClick={(e) => onHandleClick(e)}>
                    {SAVE_AND_EXIT}
                  </ActionLink>
                )}
              </SaveExitWrapper>
            </th>
          </tr>
        </table>
      </LogoContainer>
      <Container id="mainContainer">
        <TimeoutModal
          lang={lang}
          langContent={langContent}
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
          IDLE_TIMER={IDLE_TIMER}
          IDLE_TIMER_REMAINING={IDLE_TIMER_REMAINING}
          INTERVAL_TIME={INTERVAL_TIME}
          DEBOUNCE_TIME={DEBOUNCE_TIME}
        >
          <Content data-testid="content">
            <Form
              business_unit={business_unit}
              form_name={form_name}
              flow={FLOW_AUTH}
              lang={lang}
              langContent={langContent}
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
              setIsExitModalOpen={setIsExitModalOpen}
            />
          </Content>
          <Footer items={buildFooterMenus(lang)} lang={lang} />
        </TimeoutModal>
      </Container>
      <ExitModal
        lang={lang}
        isExitModalOpen={isExitModalOpen}
        onExitModalCloseHandler={() => setIsExitModalOpen(false)}
        langContent={langContent[EXIT]}
        isAuthenticated={isAuthenticated}
        setIsAuthenticated={setIsAuthenticated}
        setIsExitModalOpen={setIsExitModalOpen}
      />
    </Fragment>
  );
};

export default FormHero;
